
// import Vuex https://vuex.vuejs.org/
import Vuex from 'vuex';

// aos animations
window.AOS = require('aos');

require('hammerjs');

/**
 * Process routes based on data provided by WP back end into an object usable by VueRouter. See ./includes/class-enhighlights-content.php
 * 
 * @depend window.highlights
 * @return {arr} routes collection.
 * 
 * NOTE: The structure of the application requires that a parent component persists regardless of route scope - as such,
 * we are handing VueRouter a single parent route which owns all the highlights routes as children.
 */
function process_routes() {
        // parent routes object
    let routes = {
            path: '/',
            component: require('./components/Highlights.vue').default,
            children: []
        },
        // pre-define a loading route
        loading_route = {
            path: '',
            name: 'highlight.loading',
            component: require('./components/Loading.vue').default,
            meta: {
                title: 'loading'
            }
        },
        // pre-define a catch all 404 route
        route_not_found = {
            path: '/*',
            name: '404',
            component: require('./components/PageNotFound.vue').default,
            meta: {
                heading: 'Page Not Found',
                copy: 'The page you are search for cannot be found',
                title: 'Page Not Found',
            }
        },
        // pre-define just a blank single route shell
        route,
        module;
    
    // catch a no routes sceanrio
    if( !window.highlights ) {
        //return just the 404 path
        return [route_not_found];
    }

    // start by pushing the loading route placeholder into the children array
    routes.children.push( loading_route );

    // now go through each of the highlights objects provided by window.highlights
    for( let i = 0; i < window.highlights.length; i++ ) {
        // make sure this highlights is valid else the world will end - for the moment it's basic, just a sniff for dependent properties.
        // TODO: let's see in testing if we need to make this more robust
        if( !window.highlights[i].hasOwnProperty('path')
            || !window.highlights[i].hasOwnProperty('meta')
            || !window.highlights[i].hasOwnProperty('name')
        ) {
            // provide details to console
            console.warn( 'Highlights plugin attempted to process a malformed route definition', window.highlights[i] );
            // if this object is malformed, jump out to the next iteration
            continue;
        }

        switch( window.highlights[i].meta.type ) {
            case 'single-image':
                module = require('./components/SingleImage.vue').default;
                break;
            case 'slideshow':
                module = require('./components/Slideshow.vue').default;
                break;
            case 'movie':
                module = require('./components/Movie.vue').default;
                break;
            default:
                module = null;
                // provide details to console
                console.warn( 'unknown module type', window.highlights[i].meta.type );
                continue;
        }

        // assmble the route data
        route = {
            ...window.highlights[i],
            component: module,
        };
        // again into the children property of routes
        routes.children.push( route );
    }
    // lastly we push the route not found -- this **must always** be last in the array so that it acts as a catch all
    //routes.children.push( route_not_found );
    // the routes value is always an array (in this case containing just a single parent route with many children)
    return [routes, route_not_found];
}


/**
 * Entry block scripts - appears on non vue pages
 */
function EntryBlock() {
    this.$entry_block = document.getElementById('highlights-entry');
    this.at_rest = false;
    this.at_rest_delay = 1000;
    this.at_rest_class = 'o-entry--at-rest';
}

EntryBlock.prototype.init = function() {
    
    if( this.$entry_block && !this.at_rest ) this.set_at_rest();

    $('#highlights-entry').on('click', function(e) {
        e.preventDefault();

        let highlight_name = $(this).data('highlight-name'),
            href = $(this).attr('href');

        console.info( 'dataLayer push', { "event": "highlight_entry_click", "highlight_name": highlight_name } );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "highlight_entry_click",
            "highlight_name": highlight_name
        });

        window.location.href = !href ? '/highlights/' : href;

    });

}

EntryBlock.prototype.set_at_rest = function() {

    if( window.highlight_entry_at_rest ) clearTimeout( window.highlight_entry_at_rest );

    window.highlight_entry_at_rest = setTimeout(() => {
        this.$entry_block.classList.add( this.at_rest_class );
    }, this.at_rest_delay );
}

$(function(){
    const entry_block = new EntryBlock();
    entry_block.init();
});

/**
 * Sticky mobile nav
 */

function MobNav() {
    this.$track = document.getElementById('highlights');
    this.$header = document.getElementById('main-header');
    this.$container = document.getElementById('mobnav');
    this.scroll_position = 0;
    this.ticking = false;
    this.container_offset_top = null;
    this.affixed = false;
    this.refreshing = false;

    this.scroll_threshold = 10;
    this.scroll_direction = null;
    this.previous_direction = null;
}

MobNav.prototype.init = function() {

    this.last_scroll_position = window.scrollY;

    document.addEventListener('scroll', (e) => {

        this.scroll_direction = this.last_scroll_position < window.scrollY ? 'down' : 'up';
        
        this.last_scroll_position = window.scrollY;
      
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.updateLayout();
                this.ticking = false;
            });
      
            this.ticking = true;
        }
    });

}

MobNav.prototype.updateLayout = function() {

    if( this.previous_direction !== 'down' && this.scroll_direction === 'down' && window.scrollY > this.scroll_threshold ) {
        // hide
        this.$container.classList.add('o-mobnav--hiden');
        this.previous_direction = 'down';
    } else if( this.previous_direction !== 'up' && this.scroll_direction === 'up' ) {
        // show
        this.$container.classList.remove('o-mobnav--hiden');
        this.previous_direction = 'up';
    }
}

/**
 * Vue init for the highlight page
 */
if( document.getElementById('app') ) {

    /**
     * Components
     */
    Vue.component( 'media-container', require('./components/Media.vue').default );
    Vue.component( 'background-container', require('./components/Background.vue').default );
    Vue.component( 'preview-next', require('./components/PreviewNext.vue').default );
    Vue.component( 'timeline', require('./components/Timeline.vue').default );
    Vue.component( 'mob-nav', require('./components/MobileNav.vue').default );
    Vue.component( 'cta-button', require('./components/Button.vue').default );
    Vue.component( 'back-button', require('./components/BackButton.vue').default );
    Vue.component( 'home-button', require('./components/HomeButton.vue').default );

    /**
     * Router
     * define the routes based on the window.highlights object and hand off to VueRouter
     */
    const routes = process_routes();

    const router = new VueRouter({ routes });

    // tell vue to use Vuex
    Vue.use( Vuex );

    const store = new Vuex.Store({
        /***************************************************************************
         * DEFAULT STATE
         **************************************************************************/
        state: {
            unloading: false,
            destory: false,
            route_transition: false,
            // used as a flag in watch::$route only to prevent multiple firing
            current_route_name: null,
        },

        /***************************************************************************
         * MUTATIONS
         **************************************************************************/
        mutations: {
            set_unloading: function( state, unloading ) {
                state.unloading = unloading;
            },
            set_destroy: function( state, destroy ) {
                state.destroy = destroy;
            },
            set_route_transition: function( state, transitioning ) {
                state.route_transition = transitioning;
            },
            set_current_route_name_flag: function( state, current_route_name ) {
                state.current_route_name = current_route_name;
            },
        },
    });

    /**
     * Global properties
     */
    Vue.mixin({
        data: function () {
            return {
                highlights_data: window.highlights,
                swipe_event_active: false,
                mobnav: null,
                swiper: null,
            }
        },
        computed: {
            current_route_order: function() {
                return this.$route.meta.order;
            },
            previous_route_name: function() {
                return !isNaN( this.current_route_order ) && ( this.current_route_order - 1 ) > 0 ? `highlight.${this.current_route_order - 1}` : null;
            },
            next_route_name: function() {
                return !isNaN( this.current_route_order ) && ( this.current_route_order + 1 ) <= this.highlights_data.length ? `highlight.${this.current_route_order + 1}` : null;
            },
            next_route: function() {
                return !isNaN( this.current_route_order ) && ( this.current_route_order + 1 ) <= this.highlights_data.length ? this.highlights_data[(this.current_route_order)] : null;
            },
            unloading: function() {
                return this.$store.state.unloading;
            },
            destroy: function() {
                return this.$store.state.destroy;
            },
            final_route_name: function() {
                return this.highlights_data[(this.highlights_data.length - 1)].name;
            },
            arrived_from_final_route: function() {
                return this.$route.params.from_final_route;
            },
            current_route_name: function() {
                return this.$store.state.current_route_name;
            }
        },
        watch: {
            $route: function( to, from ) {

                if( this.current_route_name != to.name ) {
                    // the meta and title properites could be missing in some edge cases, so check for them here to avoid error
                    let title = to.meta && to.meta.title ? to.meta.title : 'Unknown';
                    this.dataLayerPush({
                        "event": "highlight_view",
                        "highlight_name": title
                    });
                    // set the flag
                    this.$store.commit( 'set_current_route_name_flag', to.name );
                }
                this.$store.commit( 'set_unloading', false );
                this.swipe_event_active = false;
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        },
        methods: {
            nextHighlight: function() {

                if( this.next_route_name ) {
                    this.goToHighlight( this.next_route_name );
                } else {
                    this.swipe_event_active = false;
                }

            },
            previousHighlight: function() {

                if( this.previous_route_name ) {
                    this.goToHighlight( this.previous_route_name );
                } else {
                    this.swipe_event_active = false;
                }

            },
            goToHighlight: function( route_name ) {

                if( route_name == this.$route.name ) return;

                let from_final_route = this.final_route_name == this.$route.name;

                this.$store.commit( 'set_unloading', true );

                setTimeout(() => {
                    this.$router.push({ name: route_name, params: { 'from_final_route': from_final_route } });
                }, 600);

                if( window.button_refresh ) clearTimeout( window.button_refresh );
                
                this.$store.commit( 'set_route_transition', true );

                if( window.button_refresh ) clearTimeout( window.button_refresh );

                window.button_refresh = setTimeout(() => {
                    this.$store.commit( 'set_route_transition', false );
                }, 2000 );

            },
            handleKeydown: function( e ) {
                switch( e.keyCode ) {
                    case 37:
                        this.previousHighlight();
                        break;
                    case 39: 
                        this.nextHighlight();
                        break;
                }
            },
            swipeLeft: function() {

                if( this.swipe_event_active ) {
                    return;
                }

                this.swipe_event_active = true;

                this.nextHighlight();
            },
            swipeRight: function() {

                if( this.swipe_event_active ) {
                    return;
                }

                this.swipe_event_active = true;

                this.previousHighlight();
            },
            dataLayerPush: function( data = null ) {

                if( !data ) {
                    return;
                }

                console.info( 'dataLayer push', data );

                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push( data );

            }
        }
    });

    /**
     * App
     * define the app
     */
    const home_app = new Vue({
        router,
        store,
        mounted() {

            this.$nextTick(() => {

                AOS.init();

                this.mobnav = new MobNav();
                this.mobnav.init();
            
            });

        },
        beforeMount() {
            window.addEventListener( 'keydown', this.handleKeydown, null );
        },
        beforeDestroy() {
            window.removeEventListener( 'keydown', this.handleKeydown );
        }
    }).$mount('#app');

}